import { UploadResumesProcessedCandidatesModule } from "../../partials/missioncontrol/addCandidates/addCandidates/uploadResumes/uploadResumesProcessedCandidates/upload-resumes-processed-candidates.module";
import { UserNotificationsComponent } from "./user-notifications.component";
export const UserNotificationsModule = angular
    .module('userNotifications', [UploadResumesProcessedCandidatesModule])
    .component(UserNotificationsComponent.selector, UserNotificationsComponent.component)
    .name;
//# sourceMappingURL=user-notifications.module.js.map